<template>
  <div style="width:100%">
    <el-row style="padding: 5px;">  
      <el-col :span="10" >
        <el-button type="success" @click="addTableData()">{{$t('button.create')}}</el-button>
        <el-tooltip class="item" effect="dark" content="Import By Excel" placement="top">
          <el-button v-if="showImport" :loading="loading"  type="primary" @click="handleUpload" >import</el-button>
        </el-tooltip>
        <el-tooltip class="item" effect="dark" content="Import As Excel" placement="top">
          <el-button v-if="showExport"  type="primary" @click="exportExcel" >export</el-button> 
        </el-tooltip>
        <input v-if="showImport" style="display:none" ref="excel-upload-input"  type="file" accept=".xlsx, .xls" @change="handleClick">       
      </el-col>   
      <el-col :span="4" :offset="10">   
          <el-input v-if="showSearch"  v-model="searchText" :placeholder="$t('msg.fuzzySearch')" >
            <i slot="prefix" class="el-input__icon el-icon-search"></i>
          </el-input>
      </el-col>  
    </el-row>
    
    <el-row>
      <el-col :span="24">
        <el-table ref="singleTable" :id="tableData.id" :data="tableData.data"  border  highlight-current-row  :empty-text="$t('msg.noDataFound')">
          <el-table-column v-for="(v, i) in tableData.columns" :prop="v.field" :label="v.title" :width="v.width" :key="i">
            <template slot-scope="scope">            
              <span v-if="currentIndex==scope.$index">     
                <EmployeeSearch v-if="v.type=='employee'" v-model="tableData.sel[v.field]" @sync-select-employee="syncSelectEmployee" :pSelectEmp="scope.row[v.field]" size="mini"/>     
                <el-date-picker  v-else-if="v.type=='date'" v-model="tableData.sel[v.field]"  type="date"  :placeholder="$t('msg.selectDate')" size="mini" style="width: 100%;"></el-date-picker>
                <el-date-picker v-else-if="v.type=='datetime'" v-model="tableData.sel[v.field]"  type="datetime"  :placeholder="$t('msg.selectDate')" size="mini" style="width: 100%;"></el-date-picker>      
                <el-select v-else-if="v.type=='select'" v-model="tableData.sel[v.field]" :placeholder="$t('msg.pleaseSelect')" size="mini">
                  <el-option v-for="item in v.selectObj" :key="item.value" :label="item.label" :value="item.value"></el-option>
                </el-select>  
                <el-input v-else size="mini" :placeholder="v.placeholder" v-model="tableData.sel[v.field]" ></el-input>
              </span>
              <span v-else>{{ scope.row[v.field] }}</span>
            </template>
          </el-table-column>
       

          <el-table-column v-if="showEditButton" :label="$t('action')" width="160">    

            <template slot-scope="scope">    
              <el-button v-if="currentIndex!=scope.$index" type="warning" @click="updTableData(scope.row, scope.$index, true)">{{$t('button.edit')}}</el-button>
              <el-button v-if="currentIndex==scope.$index" type="success" @click="updTableData(scope.row, scope.$index, true)">{{$t('button.confirm')}}</el-button>
              <el-button v-if="currentIndex!=scope.$index" type="danger" @click="delTableData(scope.row, scope.$index)">{{$t('button.delete')}}</el-button>    
              <el-button v-if="currentIndex==scope.$index" type="warning" @click="updTableData(scope.row, scope.$index, false)">{{$t('button.cancel')}}</el-button>      
            </template>
          </el-table-column>
        </el-table>      
      </el-col>
    </el-row>


  </div>
</template>
<script>
/**
 * 傳入參數的tableData內容需包含
 * 
 * 
 */


import FileSaver from 'file-saver'
import XLSX from "../../utils/xlsx.js";
import EmployeeSearch from './EmployeeSearch'
import CommonUtil from "../../utils/commonUtil.js";


export default {
  props: {
    tableData: {
      type: Object, //showExport為true時table的Id和exportName必填
      required: true
    },
    showImport: {
      type: Boolean,
      required: false,
      default:false
    },
    showExport:{
      type: Boolean,
      required: false,
      default:false
    },
    showEditButton:{
      type: Boolean,
      required: false
    },
    showSearch:{
      type: Boolean,
      required: false,
      default:false
    },
    showEdit:{
      type: Boolean,
      required: false
    }
  },
  data() {         
    return {
      loading:false,
      currentIndex:-1,
      excelData: {
        header: null,
        results: null
      },
      searchText: '',
      exportName: this.tableData.exportName+'_'+CommonUtil.dateFormat(new Date())
    };
  },   
  watch: { 
    searchText () {   
      const search = (this.searchText!=null ? this.searchText.toLowerCase() : '');
      if (search) {   
        let displayCol = [];

        this.tableData.columns.forEach((item, index) => {
          if(item.field != null && item.field!= ''){
            displayCol.push(item.field);
          }
        });
              
        this.tableData.data  = this.tableData.originalTableData.filter(dataNews => {
          return Object.keys(dataNews).some(key => {
            var inColumn = false;
            for (var col of this.tableData.columns) {
              if(col.field == key){
                inColumn = true;                
                break;
              }
            }            
            if(inColumn) return String(dataNews[key]).toLowerCase().indexOf(search) > -1
          })
        })
      }else{
         this.tableData.data = this.tableData.originalTableData.filter(dataNews => {
          return Object.keys(dataNews).some(key => {
            return String(dataNews[key]).toLowerCase().indexOf('') > -1
          })
        })
      }
    }
  },
  components: {
    EmployeeSearch
  },
  mounted() {   
    
  },
  methods: {
    readTableData() {
      
    },    
    addTableData() {
            
      if(this.currentIndex!=-1){
        return this.$message.warning({message:this.$i18n.t('msg.saveFirst'), duration: 800});
      }
      var emptyData = {};      
      this.tableData.columns.forEach((item, index) => {
        emptyData[item.field] = '';        
      });
      emptyData['action']='A';
      this.tableData.data.splice(0, 0, emptyData);
      this.tableData.sel = JSON.parse(JSON.stringify(emptyData));
      this.currentIndex = 0;

    },
    generateData({ header, results }) {
      this.excelData.header = header;
      this.excelData.results = results;
      this.tableData.data = this.excelData.results;
    },
    updTableData(row, index, cg) {      
      //是否是取消操作
      if (!cg) {
        if (!this.tableData.sel.id) this.tableData.data.splice(index, 1);
        return this.currentIndex = -1;;
      }
      if(this.currentIndex !=-1 && index != this.currentIndex){
        return this.$message.warning({message:this.$i18n.t('msg.saveFirst'), duration: 800});
      } 
      row.action = 'U';
      if (this.currentIndex !=-1 && index == this.currentIndex) {     
        let data = JSON.parse(JSON.stringify(this.modifyUpdData(this.tableData.sel)));
        for (let k in data) row[k] = data[k];  
        this.$refs.singleTable.setCurrentRow();
        //this.$message({ type: "success", message: this.$i18n.t('msg.saveSuccess'), duration: 800});
        this.currentIndex = -1;
      } else {
        this.tableData.sel = JSON.parse(JSON.stringify(this.modifyUpdData(row)));
        this.$refs.singleTable.setCurrentRow(row);
        this.currentIndex = index;
      }
    },
    modifyUpdData(data){
      
      for (var col of this.tableData.columns) {
        //employee date datetime select
        if(data[col.field]!=null && data[col.field] != ''){
          if(col.type == 'date'){
            var d = new Date(data[col.field]);
            if(d!=null){
              data[col.field] = d.getFullYear() + "-" + this.lpad(d.getMonth()+1, 2) + "-" + this.lpad(d.getDate(), 2);	
            }
            
          }if(col.type == 'datetime'){
            var d = new Date(data[col.field]);
            if(d!=null && !isNaN(d)){
              data[col.field] = d.getFullYear() + "-" + this.lpad(d.getMonth()+1, 2) + "-" + this.lpad(d.getDate(), 2) + " " +
                      this.lpad(d.getHours(), 2) + ":" + this.lpad(d.getMinutes(), 2)+ ":" +  this.lpad(d.getSeconds(), 2) ;		
            }
          }
        }
        
      }  
      return data;
    },
    lpad (str,length){
	    if(String(str).length >= length)
			  return str;
		  else
			  return this.lpad("0" +String(str),length);
	  },
    delTableData(row, index){  
      this.$confirm(this.$i18n.t('msg.confirmDelete'), {
        confirmButtonText: this.$i18n.t('button.confirm'),
        cancelButtonText: this.$i18n.t('button.cancel'),
        type: 'warning'
      })
      .then(_ => {
        this.tableData.data.splice(index, 1);
        done();
      })
      .catch(_ => {});     
    },
    handleUpload() {
      this.$refs['excel-upload-input'].click()
    },
    handleClick(e) {
      const files = e.target.files
      const rawFile = files[0] ;
      if (!rawFile) return
      this.upload(rawFile)
    },
    upload(rawFile) {
      this.$refs['excel-upload-input'].value = null;
      if (!this.beforeUpload) {
        this.readerData(rawFile)
        return
      }
      const before = this.beforeUpload(rawFile)
      if (before) {
        this.readerData(rawFile)
      }
    },
    readerData(rawFile) {
      this.loading = true
      return new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.onload = e => {
          const data = e.target.result
          const workbook = XLSX.read(data, { type: 'array' })
          const firstSheetName = workbook.SheetNames[0]
          const worksheet = workbook.Sheets[firstSheetName]
          const header = this.getHeaderRow(worksheet)
          const results = XLSX.utils.sheet_to_json(worksheet)
          this.generateData({ header, results })
          this.loading = false
          resolve()
        }
        reader.readAsArrayBuffer(rawFile)
      })
    },
    getHeaderRow(sheet) {
      const headers = []
      const range = XLSX.utils.decode_range(sheet['!ref'])
      let C
      const R = range.s.r
      /* start in the first row */
      for (C = range.s.c; C <= range.e.c; ++C) { /* walk every column in the range */
        const cell = sheet[XLSX.utils.encode_cell({ c: C, r: R })]
        /* find the cell in the first row */
        let hdr = 'UNKNOWN ' + C // <-- replace with your desired default
        if (cell && cell.t) hdr = XLSX.utils.format_cell(cell)
        headers.push(hdr)
      }
      return headers
    },
    exportExcel(){       
   
      this.currentPage= 1;
      this.$nextTick(function () {
          let xlsxParam = { raw: true };
          let wb = XLSX.utils.table_to_book(document.querySelector('#'+this.tableData.id), xlsxParam);   

          if(this.showEditButton){
            var s = wb.Sheets[wb.SheetNames[0]]
            var key = Object.keys(s)
            key.forEach((item, index) => {  
              var obj = s[item]           
              if(obj.v!= null && obj.v != '' && ( obj.v == this.$i18n.t('action') || obj.v == (this.$i18n.t('button.edit')+this.$i18n.t('button.delete')))){
                delete s[item]
              }              
            });
          }
          let wbout = XLSX.write(wb, {bookType: 'xlsx', bookSST: true, type: 'array'});
          try {
              FileSaver.saveAs(new Blob([wbout], {type: 'application/octet-stream'}), this.exportName+'.xlsx')
          } catch (e) {
              if (typeof console !== 'undefined') console.log(e, wbout)
          }      
          return wbout
      })

    },
    syncSelectEmployee(empNo){ 
      //TODO 目前只能有一個EMPLOYEE查詢, BUG待改      
      this.tableData.columns.forEach((item, index) => {
        if(item.type == 'employee'){
          this.tableData.sel[item.field] = empNo;
        }   
      });
    }
  }
};
</script>
